import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useAppSelector } from "../../app/hooks";
import { DisplayPlayer } from "../display/DisplayPlayer";
import { selectGameById } from "../games/games.feature";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AutorenewIcon from "@mui/icons-material/Autorenew";

type Props = {
  id: string;
  court: number;
};

const getTitle = (round: number, court: number) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Chip
        sx={{ fontSize: "1.2rem" }}
        icon={<AutorenewIcon />}
        label={`Round ${round}`}
      />
      <Chip
        sx={{ fontSize: "1.2rem" }}
        icon={<DashboardIcon />}
        label={`Court ${court}`}
      />
    </Box>
  );
};

export const RoundTableRow = ({ id, court }: Props) => {
  const game = useAppSelector((state) => selectGameById(state, id));

  return (
    <>
      {game ? (
        <Card elevation={4}>
          <CardHeader
            sx={{ p: 1.5 }}
            title={getTitle(game.round, court)}
            align="center"
          ></CardHeader>
          <CardContent sx={{ p: 1.5 }}>
            <Grid container>
              <Grid
                container
                alignItems="flex-start"
                direction="column"
                xs={10}
              >
                <Grid item>
                  <DisplayPlayer
                    id={game.home.playerA}
                    round={game.round}
                    variant="h4"
                  />
                </Grid>
                <Grid item>
                  <DisplayPlayer
                    id={game.home.playerB}
                    round={game.round}
                    variant="h4"
                  />
                </Grid>
              </Grid>
              <Grid container alignItems="center" justifyContent="end" xs={2}>
                <Typography variant="h2">{game.home.score}</Typography>
              </Grid>
              <Divider
                sx={{
                  my: 1,
                  borderColor: "#999",
                  width: "100%",
                }}
              />
              <Grid
                container
                alignItems="flex-start"
                direction="column"
                xs={10}
              >
                <Grid item>
                  <DisplayPlayer
                    id={game.away.playerA}
                    round={game.round}
                    variant="h4"
                  />
                </Grid>
                <Grid item>
                  <DisplayPlayer
                    id={game.away.playerB}
                    round={game.round}
                    variant="h4"
                  />
                </Grid>
              </Grid>
              <Grid container alignItems="center" justifyContent="end" xs={2}>
                <Typography variant="h2">{game.away.score}</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ) : null}
    </>
  );
};
